import { EventConfigStateService } from 'src/app/@store/event-config-state.service';
import { environment } from 'src/environments/environment';

export interface MatchmakingEventIdSources {
  configEventId?: string | null;
  sessionExpoId?: string | null;
  enrollEventName?: string | null;
}

/** Resolve x-event-id / expoId for show-winners matchmaking APIs.
 *  Event config (e.g. TWE2026 from getEventConfig) wins over stale session storage. */
export function resolveMatchmakingEventId(
  sources: MatchmakingEventIdSources = {}
): string {
  const override = environment.matchmakingEventIdOverride?.trim();
  const configId = sources.configEventId?.trim();
  const sessionId = sources.sessionExpoId?.trim();
  const enrollId = sources.enrollEventName?.trim();

  return override || configId || sessionId || enrollId || '';
}

export function resolveMatchmakingEventIdFromState(
  eventConfigState: EventConfigStateService,
  sessionExpoId?: string | null,
  enrollEventName?: string | null
): string {
  return resolveMatchmakingEventId({
    configEventId: eventConfigState.$eventIdentifier(),
    sessionExpoId,
    enrollEventName,
  });
}
